import {useEffect, useState} from 'react';
import {Settings} from './app';

export const defaultSettings: Settings = {
  operation: 'add',
  range: {min: 10, max: 100},
  entriesAmount: 20,
  mode: 'result',
  baseFactor: undefined,
};

export const useGetSettings = () => {
  const [settings, _setSettings] = useState<Settings>(defaultSettings);

  useEffect(() => {
    return;
  });

  return settings;
};
